//本地存储存取方法
import {saveToLocal, loadFromLocal} from "common/js/store"

export const getUsernameNS = state => state.username + "NS123";
export const getUserLoginStatus = (state) => {
  if (!state.userInfo) {
    return 0
  }
  return state.userInfo.loginName ? 1 : 0;
}

export const getUserSkinSign = (state) => {
  let username

  if (!state.userInfo.loginName) {
    username = 'anon'
  } else {
    username = state.userInfo.username
  }
  console.log(loadFromLocal("config", username + "skinSign", "blue"))
  return loadFromLocal("config", username + "skinSign", "blue")
}
export const getEmptyNoticeText = (state) => {
  return state.noticeEmptyListNotice
}
export const getOneEmptyNoticeText = (state) => {
  let data = state.noticeEmptyListNotice
  let randomIdx = parseInt(Math.random() * (data.length))
  return data[randomIdx].word
}
export const getImportanceGradeData = (state) => {
  let ret = []
  state.importanceData.forEach((item) => {
    ret.push({
      title: item.dictLabel,
      value: item.dictValue
    })
  })
  return ret
}
//获取待办类别
export const getTodoCategory = (state) => {
  let ret = [{
    title: '全部',
    value: -1
  }]
  state.todoCategory.forEach((item) => {
    ret.push({
      title: item.dictLabel,
      value: item.dictValue
    })
  })
  return ret
}
//获取待办部门
export const getTodoDept = (state) => {
  let ret = [{
    title: '全部',
    value: -1
  }]
  state.todoDept.forEach((item) => {
    ret.push({
      title: item.deptname,
      value: item.deptid
    })
  })
  return ret
}



// WEBPACK FOOTER //
// ./src/store/getters.js